
import { API_V2 } from './apiVersion';


export const USER_COUPON_ENDPOINTS = {
  MY_COUPONS:
    `${API_V2}/users/me/coupons`,

  AVAILABLE:
    `${API_V2}/users/me/coupons/available`,

  DETAIL: (
    userCouponId: number,
  ) =>
    `${API_V2}/users/me/coupons/${userCouponId}`,

  USE: (
    userCouponId: number,
  ) =>
    `${API_V2}/users/me/coupons/${userCouponId}/use`,
};


export const ADMIN_COUPON_ENDPOINTS = {

  LIST:
    `${API_V2}/admin/coupons`,

  ACTIVE:
    `${API_V2}/admin/coupons/active`,

  DETAIL: (
    couponId: number,
  ) =>
    `${API_V2}/admin/coupons/${couponId}`,

  CREATE:
    `${API_V2}/admin/coupons`,

  ACTIVATE: (
    couponId: number,
  ) =>
    `${API_V2}/admin/coupons/${couponId}/activate`,

  DEACTIVATE: (
    couponId: number,
  ) =>
    `${API_V2}/admin/coupons/${couponId}/deactivate`,

  ISSUE: (
    userId: string,
    couponId: number,
  ) =>
    `${API_V2}/admin/users/${userId}/coupons/${couponId}`,

  USER_COUPONS: (
    userId: string,
  ) =>
    `${API_V2}/admin/users/${userId}/coupons`,

  USER_COUPON_DETAIL: (
    userCouponId: number,
  ) =>
    `${API_V2}/admin/user-coupons/${userCouponId}`,

  USE_USER_COUPON: (
    userCouponId: number,
  ) =>
    `${API_V2}/admin/user-coupons/${userCouponId}/use`,

  CANCEL_USER_COUPON: (
    userCouponId: number,
  ) =>
    `${API_V2}/admin/user-coupons/${userCouponId}/cancel`,
};